
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import HeaderNotice from './headerNotice.vue'
import { Observer } from 'mobx-vue'
import { Bind, Debounce } from 'lodash-decorators'

@Observer
@Component({
  components: {
    HeaderNotice
  }
})
export default class HeaderNoticePop extends Vue {
  @Prop({ type: Boolean, default: false }) isTop

  showNotice: boolean = false

  hasShowModal: boolean = false

  get PageStore() {
    return this.$store.$storeUser
  }

  get noticeStore() {
    return this.PageStore.messageNotice
  }

  changeShowModal(visible: boolean) {
    this.hasShowModal = visible
  }

  @Debounce(100)
  @Bind()
  changeShowNotice() {
    this.showNotice = !this.showNotice
  }

  hideShowNotice() {
    if (this.hasShowModal === true) return

    this.showNotice = false
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
